import { get as _get } from "lodash";
import {
  ADD_FILE_REQUEST_RECORD_ERROR,
  ADD_FILE_REQUEST_RECORD_SUCCESS,
} from "../actionTypes";
const INITIAL_STATE = {
  addFileRequestRecordSuccess: null,
  addFileRequestRecordError: null
};
const fileRequestRecord = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_FILE_REQUEST_RECORD_SUCCESS:
       
      return {
        ...state,
        addFileRequestRecordError: null,
        addFileRequestRecordSuccess: _get(action,"payload")
      };
    case ADD_FILE_REQUEST_RECORD_ERROR:
      return {
        ...state,
        addFileRequestRecordSuccess: null,
        addFileRequestRecordError: action.payload
      };
    default:
      return state;
  }
};
export default fileRequestRecord;
